import React, { useEffect, useState } from 'react';
import {
  Alert, Form, Button, Toast,
} from '@roo/roo';
import dayjs from 'dayjs';
import { requiredRuleV2 } from '@utils/rules';
import { postRecommend, getRecommendInfo, getTimestamp } from '@assets/apis/base';
import UploadField from '@components/UploadPro';
import Header from '@components/HomeHeader/HomeHeader';
import './index.scss';

const { Field } = Form;

const toastSuccess = () => Toast.open({
  title: '成功提示',
  children: '发送成功',
  duration: 5000,
  theme: 'light',
  status: 'success',
});

const tip = (msg) => (
  Toast.open({
    title: msg,
    position: 'topCenter',
    duration: 0,
    status: 'info',
  })
);

const Nomination = (props) => {
  const code = props.match.params.recommendCode;
  const [recommendInfo, setRecommendInfo] = useState({});
  const initPage = async () => {
    /** 相关信息-已上传的推荐信、截止时间 */
    const info = await getRecommendInfo({ code });
    const deadline = +dayjs(info.deadline).format('X');
    /** 当前时间 */
    const timestamp = await getTimestamp();
    /** 是否已截止 */
    const isCutOff = deadline < timestamp;
    if (isCutOff) {
      tip('本期推荐已经截止');
      tip('本期推荐已经截止');
    } else {
      if (info?.letterUrl) {
        tip('您的推荐信已提交成功');
      }
    }
    const data = {
      isCutOff,
      letterUrl: info?.letterUrl || undefined,
      revokeFlag: info?.revokeFlag,
    };

    setRecommendInfo(data);
  };

  useEffect(() => {
    initPage();
  }, []);

  return (
    <div>
      <Header />
      <div className="recommend">
        <div style={{ padding: '0 auto', width: '520px', margin: '50px auto' }}>
          <h2>上传推荐信</h2>
          {
            recommendInfo.revokeFlag
            && <Alert title="申报人已撤回该申报，请确认后再提交" type="warning" icon="roo-icon-info-circle" />
          }
          <div className="recommend-tip">
            推荐信说明：
            <p>1.推荐信支持.pdf/.png/.jpg/.doc/.docx格式的文件；</p>
            <p>2.推荐信应专用于青山科技奖申报，内容包含但不限于申报人信息、推荐原因、日期、落款以及推荐专家签章（手签或清晰电子签）等，推荐申报其他项目或奖项的推荐信不能用于申报青山科技奖；</p>
            <p>3.签名只接受手写签名扫描版本，或使用手签制作的电子签章，计算机录入签名无效；</p>
            <p>4.本期推荐将于9月30日24时截止，请在截止日期前完成推荐信提交；</p>
            <p>5.如有任何关于青山科技奖的疑问或建议，请联系：010-5611 4793</p>
          </div>
          <Form
            value={{
              letterUrl: recommendInfo.letterUrl,
            }}
            onSubmit={(value, error) => {
              postRecommend({ ...value, code })
                .then((res) => {
                  toastSuccess();
                });
            }}
          >
            {
              ({ values, _, submitForm }) => (
                <>
                  <Field
                    layout="vertical"
                    name="letterUrl"
                    required
                    rule={{ ...requiredRuleV2 }}
                  >
                    {({ value, handleChange }) => (
                      <div>
                        <UploadField
                          disabled={recommendInfo.isCutOff}
                          value={value}
                          onChange={handleChange}
                          maxFiles={1}
                          type="all"
                          canPreview
                        />
                      </div>
                    )}
                  </Field>
                  <Field
                    formType="submit"
                    cols={{ field: { span: 12, offset: 0 }, label: { span: 0 } }}
                  >
                    <div className="recommend-submit">
                      <Button
                        style={{ float: 'right' }}
                        onClick={submitForm}
                        disabled={recommendInfo.isCutOff || recommendInfo.revokeFlag}
                      >
                        确认发送
                      </Button>
                    </div>
                  </Field>
                </>
              )
            }
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Nomination;
